export interface TourBox {
  top: number;
  left: number;
  width: number;
  height: number;
}

export interface TourLayout {
  spotlight: TourBox;
  bubble: { top: number; left: number };
}

const SPOTLIGHT_PADDING = 6;
const BUBBLE_GAP = 12;
const VIEWPORT_MARGIN = 16;
const BOTH_SIDES = 2;

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), Math.max(min, max));
}

/**
 * The frame around the highlighted element, and the step below it, or above when it does not fit
 * below, always kept inside the window.
 */
export function computeTourLayout({
  target,
  bubble,
  viewport,
}: {
  target: TourBox;
  bubble: { width: number; height: number };
  viewport: { width: number; height: number };
}): TourLayout {
  const spotlight = {
    top: target.top - SPOTLIGHT_PADDING,
    left: target.left - SPOTLIGHT_PADDING,
    width: target.width + SPOTLIGHT_PADDING * BOTH_SIDES,
    height: target.height + SPOTLIGHT_PADDING * BOTH_SIDES,
  };
  const below = spotlight.top + spotlight.height + BUBBLE_GAP;
  const above = spotlight.top - BUBBLE_GAP - bubble.height;
  const lowestTop = viewport.height - bubble.height - VIEWPORT_MARGIN;

  let top = clamp(below, VIEWPORT_MARGIN, lowestTop);
  if (below <= lowestTop) {
    top = below;
  } else if (above >= VIEWPORT_MARGIN && above <= lowestTop) {
    top = above;
  }

  return {
    spotlight,
    bubble: {
      top,
      left: clamp(spotlight.left, VIEWPORT_MARGIN, viewport.width - bubble.width - VIEWPORT_MARGIN),
    },
  };
}
